@if ((selectedBusiness || (parameters?.logged_user && parameters?.logged_user?.id)) && roomId()) {
  <offconon-chat-message-body
    [parameters]="parameters"
    [platform]="platform"
    [selectedBusiness]="selectedBusiness"
    [logged_user]="parameters?.logged_user"
    [roomId]="roomId()!" />
}
